export default "__VITE_ASSET__CSqkZ6A2__"